import { ChildRef } from '../../../../../lib/web/components/child-ref';
import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ModalComponent } from '../../../../../lib/web/components/modal.component';
import { ToggleSelectorComponent } from '../../atoms/toggle-selector/toggle-selector.component';

export interface SubtitleSettingsData {
    fontSize: { getValue: () => number, setValue: (value: number) => void }
}

@Component({
    selector: '.m-subtitle-settings'
})
export class SubtitleSettingsComponent extends ModalComponent<HTMLInputElement> {

    @ChildRef()
    private _fontSizeSelector: ToggleSelectorComponent = null;
    
    private _data: SubtitleSettingsData = null;

    public constructor(node: HTMLInputElement) {
        super(node);
    }    

    public onInit(): void {
        super.onInit();
        this._fontSizeSelector.addCustomEventListener('selection-changed', () => {
            const fontSize: number = (this._fontSizeSelector.selected[0] || 100) / 100;
            if (this._data.fontSize.getValue() != fontSize) {
                this._data.fontSize.setValue(fontSize);
            }            
        });
    }

    public async open(data: SubtitleSettingsData): Promise<void> {
        this._data = data;
        const fontSize: number = data.fontSize.getValue();
        this._fontSizeSelector.selected = [fontSize * 100];
        return super.open();
    }
    
    @ClickListener('.m-subtitle-settings__close')
    public onClose(): void {
        super.close();
    }

    public setDisposable(value: boolean): void {
        this.isDisposable = value;
        this._fontSizeSelector.isDisposable = value;
    }
}